import { FC } from 'react';

export const BottomButton: FC<{
  buttonTitle: string;
  clickFunc: () => void;
}> = ({ buttonTitle, clickFunc }) => {
  const onClickHandler = () => {
    clickFunc();
    window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
  };

  return <button onClick={onClickHandler}>{buttonTitle}</button>;
};
